module.exports = __webpack_public_path__ + "static/media/screenshot-section-due-dates.4bcc9091.png";